import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { BASE_URL } from './BaseUrl';
import InnerHeader from './InnerHeader';
//import FormControlLabel from '@mui/material/FormControlLabel';
import { useDispatch, useSelector } from "react-redux";
import { getRoleData } from "../Store/Role/role-action";
import Cookies from "js-cookie";
import BatchRecordReport from "./Document/BatchRecordReport";
import { pdf } from "@react-pdf/renderer";

const BatchRecord = () => {

    const [data, setData] = useState([])
    const [uid, setUid] = useState([])
    const [error, setError] = useState({})
    const [selectedYear, setSelectedYear] = useState('');
    const [course, setCourse] = useState([]);
    const currentYear = new Date().getFullYear();


    const years = [];
    for (let year = currentYear; year >= 2000; year--) {
        years.push(year);
    }




    const [value, setValue] = useState({
        course: "",
        year: "",
        yearto: "",
    })



    const validateForm = () => {
        let isValid = true
        const newErrors = {}


        if (!value.course) {
            isValid = false;
            newErrors.course = "Course is Required"
        }
        if (!value.year) {
            isValid = false;
            newErrors.year = "Year is Required"
        }
        if (!value.yearto) {
            isValid = false;
            newErrors.yearto = "Year is Reuired"
        }
        setError(newErrors)
        return isValid
    }


    async function getCourseData() {

        axios.get(`${BASE_URL}/getCourse`)
            .then((res) => {
                setCourse(res.data);
            })
            .catch((err) => {
                console.log(err);
            });

    }



    useEffect(() => {
        getCourseData()
        setError({})
    }, [])




    const handleSubmit = (e) => {
        e.preventDefault()

        if (validateForm()) {

            const data = {
                course: value.course,
                year: value.year,
                yearto: value.yearto
            }


            axios.post(`${BASE_URL}/getbatchrecord`, data)
                .then((res) => {
                    console.log(res)
                })
                .catch((err) => {
                    console.log(err)
                })
        }

    }


    const onhandleChange = (e) => {
        setValue((prev) => ({ ...prev, [e.target.name]: e.target.value }))

        const { name, value } = e.target;
        if (name === 'yearinput') {
            setSelectedYear(value);

            setValue((prev) => ({
                ...prev,
                year: value
            }))

        }
    }

    const pdfshow = async () => {

        try {
            if (validateForm()) {

                const res = await axios.post(`${BASE_URL}/getbatchrecordpdf`, { course: value.course, year: value.year, yearto: value.yearto });
                const blob = await pdf(<BatchRecordReport data={res.data.data} />).toBlob();
                const url = URL.createObjectURL(blob);
                window.open(url);
                URL.revokeObjectURL(url);

            }

        } catch (err) {

            console.log(err)

        }



    };




    const roledata = {
        role: Cookies.get(`role`),
        pageid: 48,
    };

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getRoleData(roledata));
    }, []);



    return (

        <div class="container-fluid page-body-wrapper">
            <InnerHeader />
            {/* {loading && <Loader />} */}
            <div class="main-panel"  >
                <div class="content-wrapper">
                    <div class="row">
                        <div class="col-lg-12 grid-margin stretch-card">
                            <div class="card">
                                <div class="card-body">
                                    <h4 class="card-title">Batch Report</h4>

                                    <hr></hr>

                                    <form class="forms-sample py-3" onSubmit={handleSubmit}>
                                        <div class='row'>


                                            <div class="form-group col-lg-4">
                                                <label for="exampleFormControlSelect1">Select Course<span className='text-danger'>*</span> </label>
                                                <select class="form-control form-control-lg" id="exampleFormControlSelect1"
                                                    value={value.course} onChange={onhandleChange} name='course'>
                                                    <option>Select Course</option>    
                                                    <option>All</option>
                                                    {course.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.Course_Id}>{item.Course_Name}</option>
                                                        )
                                                    })}
                                                </select>
                                                {<span className='text-danger'> {error.course} </span>}
                                            </div>


                                            <div className="form-group col-lg-4">
                                                <label htmlFor="yearInput">
                                                    Select Year From <span className="text-danger">*</span>
                                                </label>
                                                <select
                                                    className="form-control form-control-lg"
                                                    id="yearInput"
                                                    value={selectedYear}
                                                    onChange={onhandleChange}
                                                    name="yearinput"
                                                >
                                                    <option value="">--Select Year--</option>
                                                    {years.map((year) => (
                                                        <option key={year} value={year}>
                                                            {year}
                                                        </option>
                                                    ))}
                                                </select>
                                                {error.year && <span className="text-danger">{error.year}</span>}
                                            </div>


                                            <div class="form-group col-lg-4">
                                                <label for="exampleInputUsername1">Select Year To<span className="text-danger">*</span></label>
                                                <input type="text" class="form-control" id="exampleInputUsername1" value={value.yearto}
                                                    placeholder="From Year" name='yearto' onChange={onhandleChange} />
                                                {<span className='text-danger'> {error.yearto} </span>}
                                            </div>


                                        </div>

                                        <button type="submit" class="btn btn-primary mr-2">Excel</button>
                                        <button type='button' onClick={pdfshow} class="btn btn-primary">Print</button>
                                        <button type='button' onClick={() => {
                                            window.location.reload()
                                        }} class="btn btn-light">Back</button>

                                    </form>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div >
        </div >

    )
}

export default BatchRecord
